export default __webpack_public_path__ + "static/media/selamat2.32101dde.svg";